import React, { useState, useEffect } from 'react';
import '../styles/MessageSender.css';

const MessageSender = () => {
  const [userName, setUserName] = useState('');
  const [message, setMessage] = useState('');
  const [isNameSet, setIsNameSet] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Since PHP files are in the public folder, use relative URLs
  // This works because they're in the same directory as index.html
  const API_URL = ''; // Empty string for same-origin requests

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await fetch(`${API_URL}/get_messages.php`);
      const data = await response.json();
      if (data.success) {
        setMessages(data.messages);
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
    }
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (userName.trim()) {
      setIsNameSet(true);
      setError('');
    }
  };

  const handleMessageSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/send_message.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_name: userName,
          message: message.trim()
        }),
      });

      const data = await response.json();

      if (data.success) {
        setMessage('');
        fetchMessages();
      } else {
        setError(data.message || 'Failed to send message');
      }
    } catch (err) {
      setError('Network error. Please check your connection.');
      console.error('Error sending message:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  if (!isNameSet) {
    return (
      <div className="message-container">
        <div className="name-entry-card">
          <h2>Welcome to Message Board</h2>
          <p>Please enter your name to start messaging</p>
          <form onSubmit={handleNameSubmit}>
            <input
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Enter your name..."
              className="name-input"
              maxLength={50}
              autoFocus
            />
            <button type="submit" className="submit-btn">
              Join Chat
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="message-container">
      <div className="chat-header">
        <h2>Message Board</h2>
        <div className="user-info">
          <span>Logged in as: <strong>{userName}</strong></span>
          <button 
            onClick={() => setIsNameSet(false)} 
            className="change-name-btn"
          >
            Change Name
          </button>
        </div>
      </div>

      <div className="messages-list">
        {messages.length === 0 ? (
          <div className="no-messages">No messages yet. Be the first to send one!</div>
        ) : (
          messages.map((msg) => (
            <div 
              key={msg.id} 
              className={`message-bubble ${msg.user_name === userName ? 'own-message' : ''}`}
            >
              <div className="message-header">
                <span className="message-user">{msg.user_name}</span>
                <span className="message-time">{formatTimestamp(msg.created_at)}</span>
              </div>
              <div className="message-content">{msg.message}</div>
            </div>
          ))
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleMessageSubmit} className="message-form">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
          className="message-input"
          maxLength={500}
          disabled={isLoading}
          autoFocus
        />
        <button 
          type="submit" 
          className="send-btn"
          disabled={isLoading || !message.trim()}
        >
          {isLoading ? 'Sending...' : 'Send'}
        </button>
      </form>
    </div>
  );
};

export default MessageSender;